import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const digitPattern = '#';

const MaskInput = React.forwardRef(({ value, pattern, onChange, ...props }, ref) => { // eslint-disable-line no-unused-vars
  const maskedInputReference = useRef(null);
  const [lastValue, setLastValue] = useState('');

  const unMaskValue = (maskedValue) => {
    const removePattern = (prevResult, char) => ((Number.isNaN(parseInt(char, 10))) ? prevResult : `${prevResult}${char}`);
    const unmaskedValue = maskedValue.split('').reduce(removePattern, '');
    return unmaskedValue;
  };

  const addMaskToValue = (inValue) => {
    if (inValue.length > pattern.length) { return lastValue; }
    let valueIndex = 0;
    const applyPattern = (prevResult, patternCharacter) => {
      if (!inValue[valueIndex]) { return prevResult; }
      let nextCharacter = patternCharacter;
      if (patternCharacter === digitPattern) {
        nextCharacter = (Number.isNaN(parseInt(inValue[valueIndex], 10))) ? '' : inValue[valueIndex];
        valueIndex++;
      }
      const newResult = `${prevResult}${nextCharacter}`;
      return newResult;
    };
    const masked = pattern.split('').reduce(applyPattern, '');
    setLastValue(masked);
    return masked;
  };

  const handleOnChange = (event) => {
    const newEvent = { ...event };
    const { target: { value: inValue } } = event;
    const rawValue = (inValue.length) ? unMaskValue(inValue) : inValue;
    const newMaskedValue = addMaskToValue(rawValue);
    newEvent.target.value = newMaskedValue;
    maskedInputReference.current.value = newMaskedValue;
    if (onChange) { onChange(newEvent); }
  };

  return <Input {...props} value={lastValue} ref={maskedInputReference} onChange={handleOnChange} />;
});

MaskInput.propTypes = {
  pattern: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default MaskInput;
